/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from '../../utils/axiosInstance';

// ----------------------------------------------------------------------

const url = process.env.BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  listVisaCountry: [],
  listVisa: [],
  listVisaDetail: undefined,
  enquiryDetail: undefined,
};

const slice = createSlice({
  name: 'visa',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getlistVisaCountrySuccess(state, action) {
      state.isLoading = false;
      state.listVisaCountry = action.payload;
    },
    getlistVisaSuccess(state, action) {
      state.isLoading = false;
      state.listVisa = action.payload;
    },
    getlistVisaDetailSuccess(state, action) {
      state.isLoading = false;
      state.listVisaDetail = action.payload;
    },
    getVisaEnquirySuccess(state, action) {
      state.isLoading = false;
      state.enquiryDetail = action.payload;
    },
    getBannerImageSuccess(state, action) {
      state.isLoading = false;
      state.getVisaBannerImage = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
//   getCart,
//   addToCart,
//   resetCart,
//   gotoStep,
//   backStep,
//   nextStep,
//   deleteCart,
//   createBilling,
//   applyShipping,
//   applyDiscount,
//   increaseQuantity,
//   decreaseQuantity
// } = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function getlistVisaCountry(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/visa/listCountries`);

      dispatch(
        slice.actions.getlistVisaCountrySuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getlistVisa(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/visa/listVisa`,
        filterParam
      );

      dispatch(slice.actions.getlistVisaSuccess(response.data.visadetails));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getlistVisaDetail(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/visa/visagetByid`,
        filterParam
      );

      dispatch(
        slice.actions.getlistVisaDetailSuccess(response.data.visaDetail)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getVisaEnquiry(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/visa/enquiry`,
        filterParam
      );

      dispatch(slice.actions.getVisaEnquirySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBannerImage() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url}/visa/listVisaBanner`);

      dispatch(
        slice.actions.getBannerImageSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearError() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    dispatch(slice.actions.hasError(null));
  };
}
